<!--
 * @Author: qh_feng
 * @Date: 2022-03-16 11:33:47
 * @LastEditTime: 2022-12-15 16:31:11
 * @LastEditors: your name
 * @Description:
 * @ FilePath: Do not edit
 * @par 修改日志:
 * 内容: showformitem=['传对应字段显示它']
 具体看 carFormindex.js 有参入参数说明
-->
<template>
  <div class="noinspected_form" ref="formQuery">
    <el-form
      :inline="true"
      :model="form"
      class="form"
      size="small"
      ref="ruleForm"
    >
      <el-form-item
        :label="item.label"
        v-for="(item, index) in formlist"
        :key="index"
      >
        <div class="car_plate" v-if="item.type == 1">
          <div class="plate_prefix">
            <el-select v-model="form[item.formV1]" placeholder="空" clearable>
              <el-option
                v-for="item2 in select[item.select]"
                :key="item2.code"
                :label="item2.name"
                :value="item2.code"
              >
              </el-option>
              <div></div>
            </el-select>
          </div>
          <div class="plate_plateNumber">
            <el-input v-model="form[item.formV2]"></el-input>
          </div>
          <el-tooltip effect="dark" placement="right">
            <div slot="content">
              模糊查询使用例如查询”粤A6734X”,<br />只需要搜索这个车牌单个或多个任意相连的字符,<br />例如”
              粤A6”,” A673”
            </div>
            <span
              style="
                color: #fff;
                width: 20px;
                height: 32px;
                line-height: 32px;
                font-size: 14px;
                cursor: pointer;
                text-align: center;
              "
            >
              ?</span
            >
          </el-tooltip>
        </div>
        <div
          v-else-if="item.type == 2"
          :style="{ width: item.width ? item.width : '150px' }"
        >
          <el-select v-model="form[item.formV]" placeholder="全部" clearable filterable>
            <el-option
              v-for="item2 in select[item.select]"
              :key="item2.code || item2.value"
              :label="item2.name || item2.lable"
              :value="item.formV == 'carColor' ? item2.funCode : item2.code || item2.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="placeholder-style uu-mytime" v-else-if="item.type == 3">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="form[item.formV]"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="-"
            :clearable="false"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          >
          </el-date-picker>
        </div>
        <div
          v-else-if="item.type == 4"
          :style="{
            /*width: item.width ? item.width : '150px'*/
          }"
        >
          <el-select
            v-model="form[item.formV]"
            placeholder="选择"
            @change="vehicleModelStyles($event)"
          >
            <el-option-group
              v-for="(group, name) in select[item.select]"
              :key="name"
              :label="name"
            >
              <el-option
                v-for="(item2, name1) in group"
                :key="item2"
                :label="name1"
                :value="item2"
              >
              </el-option>
            </el-option-group>
          </el-select>
          <el-select
            v-model="form.vehicleBrandModel"
            placeholder="选择"
            @change="vehicleModelStyles($event, true)"
          >
            <el-option
              v-for="(item3, name2) in select.vehicleBrandModel"
              :key="name2"
              :label="item3"
              :value="name2"
            >
            </el-option>
          </el-select>
          <el-select v-model="form.vehicleBrandStyles" placeholder="选择">
            <el-option
              v-for="(item4, name3) in select.vehicleBrandStyles"
              :key="name3"
              :label="item4"
              :value="name3"
            >
            </el-option>
          </el-select>
        </div>
        <div
          v-else-if="item.type == 5"
          :style="{ width: item.width ? item.width : '150px' }"
        >
          <el-select
            v-model="form[item.formV]"
            multiple
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="item2 in select[item.select]"
              :key="item2.code"
              :label="item2.name"
              :value="item2.code"
            >
            </el-option>
          </el-select>
        </div>
        <div
          v-else-if="item.type == 6"
          :style="{ width: item.width ? item.width : '150px' }"
        >
          <el-input v-model="form[item.formV]"></el-input>
        </div>
        <el-button
          type="info"
          @click="deviceSelec"
          v-else-if="item.type == 7"
          size="small"
          >设备选择</el-button
        >
        <div class="placeholder-style" v-else-if="item.type == 8">
          <div
            :style="{ width: item.width ? item.width : '150px' }"
            style="display: inline-block;"
          >
            <el-select v-model="form[item.formV]" placeholder="请选择">
              <el-option
                v-for="item in select[item.formV]"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="form[form[item.formV]]"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          >
          </el-date-picker>
        </div>
        <div class="placeholder-style" v-else-if="item.type == 9">
          <el-time-picker
            is-range
            value-format="HH:mm:ss"
            v-model="form[item.formV]"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            align="right"
          >
          </el-time-picker>
        </div>
        <div class="only-placeholder-style" v-else-if="item.type == 10">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="form['beginTime']"
            type="datetime"
            align="right"
            :placeholder="
              defaultTypeTime.passingTime_beginTime || '选择开始时间'
            "
          >
          </el-date-picker>
          <span>至</span>
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="form['endTime']"
            type="datetime"
            align="right"
            :placeholder="defaultTypeTime.passingTime_endTime || '选择结束时间'"
          >
          </el-date-picker>
        </div>
        <div class="only-placeholder-style" v-else-if="item.type == 11">
          <el-date-picker   
            value-format="yyyy-MM-dd"
            type="date"
            v-model="form[item.formV]"
          ></el-date-picker>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" size="small"
          >查询</el-button
        >
        <el-button @click="resetForm('ruleForm')" size="small">重置</el-button>
        <slot></slot>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getFormList, getformfield } from "./carFormindex.js";
export default {
  props: {
    showformitem: {
      type: Array,
      default: () => {
        return [];
      }
    },
    defaultFormValue: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      formlist: [], //表单排列顺序
      defaultTypeTime: {},
      select: {},
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      form: getformfield(),
      formheight: "" //本组件最终高度
    };
  },
  methods: {
    onSubmit() {
      console.log("查询表单提交", this.form);
      /*   if (this.showformitem.includes("selection")) {
        console.log("设备选择", this.$store.state.deviceID);
        this.deviceID = this.$store.state.deviceID;
      } */
      if (
        this.showformitem.includes("passTime") &&
        this.form.passTime.length > 0
      ) {
        this.form.passTime =
          this.form.passTime[0] + "," + this.form.passTime[1];
      }
      if (this.form["0"]) {
        this.form.beginTime = this.form["0"][0];
        this.form.endTime = this.form["0"][1];
      } else {
        this.form.beginTime =
          this.form.beginTime || this.defaultTypeTime.timeTpye_beginTime;
        this.form.endTime =
          this.form.endTime || this.defaultTypeTime.timeTpye_endTime;
      }
      /*  const sendForm = JSON.parse(JSON.stringify(this.form));
      sendForm.startDatetime = this.form.cartime && this.form.cartime[0];
      sendForm.endDatetime = this.form.cartime && this.form.cartime[1];
      sendForm.plateNo = this.form.carprefix + this.form.plateNo;
      sendForm.cardPlateNumber =
        this.form.rfid_carprefix + this.form.rfidPlateNumber; */
      //console.log("过滤表单后字段", this.form);
      const plateNo = this.form.carprefix + this.form.plateNo;
      this.$emit("submit", { ...this.form, plateNo });
    },
    deviceSelec() {
      window.$commit("selectCard_dialogVisible", true);
    },
    resetForm(formName) {
      this.form = getformfield();
    },
    //获取子品牌或车辆年代款
    vehicleModelStyles(val, type) {
      // console.log('品牌',val,type);
      this.form.vehicleBrandStyles = "";
      if (type) {
        this.$http
          .GET_vehicleStyles({ id: `${this.form.vehicleBrandModel}/${val}` })
          .then(res => {
            //console.log('品牌年代款,',res)
            // this.select.vehicleBrandModel=res.data
            this.$set(this.select, "vehicleBrandStyles", res.data);
          });
      } else {
        this.form.vehicleBrandModel = "";
        this.$http.GET_vehicleModel({ id: val }).then(res => {
          //console.log('品牌型号请求,',res)
          // this.select.vehicleBrandModel=res.data
          this.$set(this.select, "vehicleBrandModel", res.data);
        });
      }
    }
  },
  async created() {
    const obj = await getFormList(this.showformitem);
    this.formlist = obj.formlist;
    this.select = obj.selectoption;
    if(Object.keys(this.defaultFormValue)[0] == 'tableName'){
      return this.form.tableName = Object.values(this.defaultFormValue)[0][0]
    }
    if (this.defaultFormValue.toString() != "{}") {
      for (let key in this.defaultFormValue) {
        if (key == "0") {
          this.defaultTypeTime.timeTpye_beginTime = this.defaultFormValue[
            key
          ][0];
          this.defaultTypeTime.timeTpye_endTime = this.defaultFormValue[key][1];
          // this.form[key] = this.defaultFormValue[key];
          this.$set(this.form, key, this.defaultFormValue[key]);
        }
        // else if (key == "passingTime") {
        //   this.defaultTypeTime.passingTime_beginTime = this.defaultFormValue[
        //     key
        //   ][0];
        //   this.defaultTypeTime.passingTime_endTime = this.defaultFormValue[
        //     key
        //   ][1];
        // }
        else {
          this.$set(this.form, key, this.defaultFormValue[key]);
        }
      }
    }
    // console.log('carform',this.form)
    //const url = window.location.protocol + "//" + window.location.host + "/";//获取浏览器地址和端口
  },
  mounted() {
    /* if (this.$parent.hasOwnProperty("height")) {
      const height1=this.$refs.formQuery.clientHeight+6+ "px";
      this.$parent.height=`calc(94% - ${height1})`;
    } */
  }
};
</script>

<style lang="scss">
.el-date-range-picker {
  .el-button.el-picker-panel__link-btn.el-button--text {
    display: none;
  }
}
.noinspected_form {
  width: 100%;
  .placeholder-style .el-date-editor--datetimerange {
    margin-top: -2px;
    input::-webkit-input-placeholder {
      color: #aab2bd;
      font-size: 12px;
    }
    .el-range-input {
      width: 55% !important;
    }
  }
  .only-placeholder-style {
    span {
      color: #ffffff;
    }
    i {
      display: none;
    }
    .el-date-editor--datetime {
      width: 140px;
    }
  }
  .el-form-item__label {
    padding: 0 5px 0 0;
  }

  .el-input__inner {
    padding: 0 5px;
  }

  .el-date-editor--datetimerange.el-input__inner {
    width: 310px;
  }

  .form {
    .el-form-item__label {
      width: auto;
      text-align: right;
      color: #fff;
      font-size: 0.18rem;
    }

    .car_typ2 {
      width: 150px;
    }

    width: 100%;

    .car_plate {
      display: flex;

      .plate_prefix {
        width: 50px;
        margin-right: 4px;

        .el-input__icon {
          width: 20px;
        }
      }

      .plate_plateNumber {
        width: 80px;
      }
    }

    .car_color {
      width: 150px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/form/carForm.vue